<script setup lang="ts">
import { AbcAccordion, type AbcAccordionItem } from "@ordbogen-npm/abc-dsk";
import { computed } from "vue";

type Item = Record<string, string>;

const props = defineProps<{
  items: Item[];
}>();

const headers = computed<string[]>(() => Object.keys(props.items[0]));
const firstHeader = computed<string>(() => headers.value[0]);

const items = computed<AbcAccordionItem<Item>[]>(() =>
  props.items.map((item) => ({
    id: item[Object.keys(item)[0]],
    data: item
  }))
);
</script>

<template>
  <AbcAccordion
    id="irregular-verbs"
    class="irregular-verbs-accordion"
    :items="items"
    panel-class="irregular-verbs-accordion__panel"
  >
    <template #buttonContent="{ data }">
      <span class="irregular-verbs-accordion__btn-content">
        <span class="irregular-verbs-accordion__btn-form">{{ firstHeader }}</span>
        <span class="irregular-verbs-accordion__btn-verb">{{ data[firstHeader] }}</span>
      </span>
    </template>

    <template #panel="{ data }">
      <dl class="irregular-verbs-accordion__list">
        <div v-for="(header, headerIndex) in headers" :key="headerIndex">
          <dt class="irregular-verbs-accordion__list-form">{{ header }}</dt>
          <dd class="irregular-verbs-accordion__list-verb">{{ data[header] }}</dd>
        </div>
      </dl>
    </template>
  </AbcAccordion>
</template>
